/**This component comes into action upon clicking edit button on Donate section of registered user */

import {
	AfterViewInit,
	Component,
	OnInit,
	OnDestroy,
	SecurityContext,
	HostListener,
} from '@angular/core';
import { ProfileService } from 'src/app/pages/user/profile/services/profile.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DeleteWidgetStyleComponent } from '../../dialogs/delete-widget-style/delete-widget-style';
import { timer } from 'rxjs';
import { Tools } from 'src/utilities/tools';
import { environment } from 'src/environments/environment';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgIf, NgClass, NgStyle } from '@angular/common';

// import { nodeHtmlToImage } from 'node-html-to-image';

export interface styleData {
	preview: any;
	fundriaserName: any;
	htmlCode: any;
	action: any;
}

let ELEMENT_DATA: styleData[] = [];

@Component({
    selector: 'fundraiser-widget.html',
    templateUrl: './fundraiser-widget.html',
    standalone: true,
    imports: [NgIf, NgClass, ExtendedModule, FlexModule, MatCardModule, MatButtonModule, MatTableModule, NgStyle, MatTooltipModule, MatIconModule, MatFormFieldModule, PageLoaderComponent]
})
/** *Custom Donation Form Component */
export class fundraiserWidgetComponent implements OnInit, AfterViewInit {
	matTooltip = $localize`:@@share_fundraiser_tooltip_copy_code: Copy`;
	matTooltipEditWidget = $localize`:@@edit_widget_tooltip: Edit`;
	matTooltipDeleteWidget = $localize`:@@delete_widget_tooltip: Delete`;

	style_id: any;
	apiKey: any;
	shortcode: any;
	isLoading: boolean = true;
	buttonDisable: boolean = false;

	buttonColor = '';
	buttonStates: { [key: string]: boolean } = {};

	displayedColumns: string[] = [
		'preview',
		'fundraiserName',
		'htmlCode',
		'action',
	];
	dataSource = ELEMENT_DATA;

	screenWidth: number = 0;
	scriptUrl: string | undefined;
	cssUrl: string | undefined;

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.screenWidth = window.innerWidth;
	}

	/**
	 * Constructor
	 */
	constructor(
		private _profileService: ProfileService,
		public fundraiserService: FundraiserService,
		public _accountService: AccountService,
		private sanitizer: DomSanitizer,
		private router: Router,
		public dialog: MatDialog
	) {}

	ngAfterViewInit(): void {
		
	}

	ngOnInit(): void {
		if (environment.production == true) {
			this.scriptUrl = 'https://plugin.whydonate.com/wp_styling.js';
			this.cssUrl = 'https://plugin.whydonate.com/wdplugin-style.css';
		} else {
			this.scriptUrl = 'https://plugin.whydonate.com/wp_styling_development.js';
			this.cssUrl = 'https://plugin.whydonate.com/wdplugin-style-development.css';
		}
		Tools.setPreviousPath('');
		this.screenWidth = window.innerWidth;
		this._profileService.getApiKey().subscribe((res: any) => {
			if (res && res.data.response == 'ApiKeyNotAvailable') {
				this.apiKey = '';
			} else {
				this.apiKey = res.data.data.api_key;
			}
			this.fundraiserService
				.getUserFundraiserListByApiKey(this.apiKey)
				.subscribe((res: any) => {
					if (!Array.isArray(res.data)) {
						res.data = [];
					}
					if (res.data.length == 0) {
						this.buttonDisable = true;
					}
				});
			this.list_generator(this.apiKey);
		});
	}

	private list_generator(apiKey: any) {
		this.fundraiserService
			.getAllWidgetStylesByApiKey(apiKey)
			.subscribe((res: any) => {
				let styles = res.data.styles;
				let previewImgUrl = '';

				const filteredData = styles.map((item: any) => {
					switch (true) {
						case item.doNotShowBox == 1:
							previewImgUrl =
								'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/Card_type-2/public';
							break;

						case item.showDonationFormOnly == 0 && item.background_allowed == 0:
							previewImgUrl =
								'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/Card_type-3/public';
							break;

						case item.showDonationFormOnly == 1 && item.background_allowed == 0:
							previewImgUrl =
								'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/wpPreviewForm/public';
							break;

						case item.showDonationFormOnly == 0 && item.background_allowed == 1:
							previewImgUrl =
								'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/Card_type/public';
							break;

						case item.showDonationFormOnly == 1 && item.background_allowed == 1:
							previewImgUrl =
								'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/Card_type-1/public';
							break;

						default:
							break;
					}
					return {
						id: item.id,
						preview: previewImgUrl, // Assuming result has a 'value' property
						fundraiserName: item.fundraiserName,
						htmlCode: this.generateWidgetHTML(
							item.shortcode,
							item.successUrl,
							item.failureUrl
						),
						shortcode: item.shortcode,
						successUrl: item.successUrl,
						failureUrl: item.failureUrl,
					};
				});

				const ELEMENT_DATA: styleData[] = filteredData;
				this.dataSource = filteredData;
				this.isLoading = false;
			});
	}

	generateWidgetHTML(shortcode: any, successUrl: any, failUrl: any) {
		// Get the current locale
		// var locale = this._accountService.getLocaleId();

		var html = '';
		html += '<div>';
		html += '    <div';
		html += `        id="widget-here-${shortcode}"`;
		html += '        class="widget-here"';
		html += '        data-shortcode="' + shortcode + '"';
		html += '        data-lang="auto"';
		// html += '        data-success_url="' + successUrl + '"';
		// html += '        data-fail_url="' + failUrl + '"';
		html += '        value="donation-widget"';
		html += '    ></div>';
		html += '</div>';
		html += '<link';
		html += '    rel="stylesheet"';
		html += '    href="' + this.cssUrl + '"';
		html += '/>';
		html += '<script';
		html += '    src="' + this.scriptUrl + '"';
		html += '    type="text/javascript"';
		html += '></script>';
		return html;
	}
	truncateText(text: string, maxLength: number): string {
		if (this.screenWidth <= 1024) {
			maxLength = 100;
		}
		if (text.length <= maxLength) {
			return text;
		}
		return text.slice(0, maxLength) + '...';
	}

	redirectToEdit(shortcode: any) {
		// Navigate to the edit path
		this.router.navigate([`/fundraising/widget/${shortcode}`]);
	}

	// deleteStyle(shortcode: any) {
	// 	this.fundraiserService
	// 		.deleteUserStyleByApiKey(this.apiKey, shortcode)
	// 		.subscribe((res: any) => {
	// 			this.list_generator(this.apiKey);
	// 		});
	// }

	// generateRandomCombination() {
	// 	const characters =
	// 		'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
	// 	const combinationLength = 5;

	// 	let randomCombination = '';

	// 	for (let i = 0; i < combinationLength; i++) {
	// 		const randomIndex = Math.floor(Math.random() * characters.length);
	// 		randomCombination += characters[randomIndex];
	// 	}

	// 	return randomCombination;
	// }

	redirectToCreate() {
		// Navigate to the edit path
		this.router.navigate([
			`/fundraising/widget/create`,
			// `/fundraising/widget/${this.generateRandomCombination()}`,
		]);
	}

	copyHtmlCode(shortcode: any, successUrl: any = '', failUrl: any = '') {
		// Navigate to the edit path
		// Create a temporary textarea element
		const textarea = document.createElement('textarea');
		textarea.value = this.generateWidgetHTML(shortcode, successUrl, failUrl);

		// Append the textarea to the document
		document.body.appendChild(textarea);

		// Select the text in the textarea
		textarea.select();

		// Execute the copy command
		document.execCommand('copy');

		// Remove the temporary textarea
		document.body.removeChild(textarea);
	}

	// Delete WIdget Functionality
	openDeleteFundraiserDialog(shortcode: any) {
		const dialogRef = this.dialog.open(DeleteWidgetStyleComponent, {
			data: { apiKey: this.apiKey, shortcode: shortcode },
		});
		dialogRef.afterClosed().subscribe((result: any) => {
			if (result) {
				let subscribe = timer(1000).subscribe((val) => {
					this.list_generator(this.apiKey);
					this.router.navigate(['/fundraising/widget']);
					subscribe.unsubscribe();
				});
			}
		});
	}

	onMouseDown(shortcode: string) {
		this.buttonStates[shortcode] = true;
	}

	onMouseUp(shortcode: string) {
		this.buttonStates[shortcode] = false;
	}
}
